import React from "react";
import UlLi, {scrollTo, mountCode, initDeepLinkData} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import UserHandler from "js/utilities/user-handler";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar"

export default React.createClass({
  displayName: "",
  getInitialState: function() {
    var data  = [];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      navMenuParent: null,
      navMenu: null,
      android_release_version: "",
      android_release_date: "",
      ios_release_version: "",
      ios_release_date: "",
      server_java_release_version: "",
      server_java_release_date: "",
      server_c_release_version: "",
      server_c_release_date: "",
      zoom_web_release_version: "",
      zoom_web_release_date: "",
      scrollToElement: scrollToElement
    };
  },
  componentDidMount: function() {
    mountCode(this);

    // if((window.location.href).indexOf("qa") == -1 && (window.location.href).indexOf("localhost") == -1) {
    //   var d = new Date();
    //   var amOrPm = (d.getHours() < 12) ? "AM" : "PM";
    //   var dateString = (("0"+(d.getMonth()+1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + "-" + d.getFullYear() + " " +
    //                     ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2) + " " + amOrPm);
    //
    //   let data = {
    //     channel: "# zz-errors-0",
    //     "username": "incoming-webhook",
    //     "text": ":ghost: " + dateString + " - SDK - Page not found - " + window.location.href
    //   };
    //
    //   let myInit = {
    //     method: "POST",
    //     body: JSON.stringify(data)
    //   };
    //   fetch("https://hooks.slack.com/services/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", myInit)
    //     .then( (response) => {
    //
    //     })
    //     .catch( err => {
    //       console.log(err);
    //     })
    // }
  },
  render: function() {
    var url = window.location.origin;
    if (FN_MODE !== "qa") {
      url += "/zoomsdk";
    }
    url += "/#docs"
    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container">
            <section className="docs-info">
            </section>

          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/notfound.jsx